import React, { useState, useEffect, useRef } from 'react';
import Axios from 'axios';
import "../ShippingData.css";
import "./Add_Part_Dataset.css";
import { Host } from '../App';

function Part_R_Map() {
  const token = window.localStorage.getItem("acessToken");
  let rawName = window.localStorage.getItem("Name") || "";
  const userName = rawName.replace(/[{}"']/g, "").trim();

  const [editable, setEditable] = useState(false);
  const [updateable, setUpdateable] = useState(false);
  const [fullEditMode, setFullEditMode] = useState(false);
  const [del, setDel] = useState(0);
  const [partRMap, setPartRMap] = useState([]);
  const [auditLogs, setAuditLogs] = useState([]);
  const [showAudit, setShowAudit] = useState(false);
  const originalDataRef = useRef([]);

  const [data, setData] = useState([
    { f_internal_no: "", r_internal_no: "", effective_from: "", effective_to: "", note: "" }
  ]);

  const [filters, setFilters] = useState({
    f_internal_no: "", r_internal_no: "", effective_from: "", effective_to: "", note: ""
  });

  // Fetch main data
  useEffect(() => {
    Axios.get(`https://${Host}/api/get/partRMap`, {
      params: { ...filters, token }
    }).then((res) => setPartRMap(res.data));
  }, [filters, del, token]);

  // Fetch audit logs
  const fetchAuditLogs = () => {
    Axios.get(`https://${Host}/api/get/partRMap/auditLog`, { params: { token } })
      .then(res => { setAuditLogs(res.data); setShowAudit(true); })
      .catch(err => console.error(err));
  };

  // Add row
  const addRow = () => setData([...data, { f_internal_no: "", r_internal_no: "", effective_from: "", effective_to: "", note: "" }]);
  const removeRow = (index) => setData(data.filter((_, i) => i !== index));

  // Submit multiple new rows
  const submitRows = () => {
    const filteredData = data.filter(row => row.f_internal_no && row.r_internal_no);
    if (filteredData.length === 0) {
      alert("Please fill at least F Internal No and R Internal No");
      return;
    }
    Axios.post(`https://${Host}/api/add/partRMap`, { Data: filteredData, token })
      .then((response) => {
        if (response.status === 200) {
          alert(response.data.message);
          setData([{ f_internal_no: "", r_internal_no: "", effective_from: "", effective_to: "", note: "" }]);
          setEditable(false);
          setDel(del + 1);
        }
      });
  };

  // Original inline edit (only effective_from, effective_to, note)
  const handleUpdateChange = (index, field, value) => {
    const updated = [...partRMap];
    updated[index][field] = value;
    setPartRMap(updated);
  };

  const saveOriginalUpdates = () => {
    Axios.post(`https://${Host}/api/partRMap/Update`, { changedData: JSON.stringify(partRMap), token })
      .then((response) => {
        if (response.status === 200) {
          alert(response.data.message);
          setUpdateable(false);
          setDel(del + 1);
        }
      });
  };

  // Full edit mode handlers
  const handleFullEditChange = (index, field, value) => {
    const updated = [...partRMap];
    updated[index][field] = value;
    setPartRMap(updated);
  };

  const isRowChanged = (original, current) => {
    return (original.f_internal_no !== current.f_internal_no ||
      original.r_internal_no !== current.r_internal_no ||
      original.effective_from !== current.effective_from ||
      original.effective_to !== current.effective_to ||
      original.note !== current.note);
  };

  const saveFullEdits = () => {
    const changedRows = [];
    for (let i = 0; i < partRMap.length; i++) {
      const original = originalDataRef.current[i];
      const current = partRMap[i];
      if (original && isRowChanged(original, current)) {
        changedRows.push({ original, current });
      }
    }
    if (changedRows.length === 0) {
      alert("No changes detected.");
      setFullEditMode(false);
      return;
    }
    Axios.post(`https://${Host}/api/partRMap/UpdateAll`, {
      changedRows: changedRows,
      token,
      userName
    }).then((response) => {
      if (response.status === 200) {
        alert(response.data.message);
        setFullEditMode(false);
        setDel(del + 1);
      } else {
        alert(response.data.message || "Update failed");
      }
    }).catch(err => alert("Error updating data"));
  };

  const cancelFullEdits = () => {
    setFullEditMode(false);
    setDel(del + 1); // refetch
  };

  const enableFullEdit = () => {
    originalDataRef.current = JSON.parse(JSON.stringify(partRMap));
    setUpdateable(false);
    setFullEditMode(true);
  };

  const enableUpdateable = () => {
    setFullEditMode(false);
    setUpdateable(true);
  };

  const isAuthorizedForFullEdit = () => {
    const name = userName.toLowerCase();
    return name === "kenil shah" || name === "vikas harkyal";
  };

  return (
    <div className="MainPage_data">
      <div className="Container">
        <br /><h2 style={{ padding: 10 }}>Part R Map</h2><br />

        {/* ADD SECTION */}
        {editable && (
          <div className="add_section">
            <center>
              {data.map((line, index) => (
                <div key={index} className="row mb-3" style={{ borderBottom: "1px solid #ddd", paddingBottom: 10 }}>
                  <div className="col"><label>F Internal No</label>
                    <input type="text" className="form-control" list="FInternalNoList" value={line.f_internal_no}
                      onChange={(e) => { const newData = [...data]; newData[index].f_internal_no = e.target.value; setData(newData); }} />
                  </div>
                  <div className="col"><label>R Internal No</label>
                    <input type="text" className="form-control" list="RInternalNoList" value={line.r_internal_no}
                      onChange={(e) => { const newData = [...data]; newData[index].r_internal_no = e.target.value; setData(newData); }} />
                  </div>
                  <div className="col"><label>Effective From</label>
                    <input type="date" className="form-control" value={line.effective_from}
                      onChange={(e) => { const newData = [...data]; newData[index].effective_from = e.target.value; setData(newData); }} />
                  </div>
                  <div className="col"><label>Effective To</label>
                    <input type="date" className="form-control" value={line.effective_to}
                      onChange={(e) => { const newData = [...data]; newData[index].effective_to = e.target.value; setData(newData); }} />
                  </div>
                  <div className="col"><label>Note</label>
                    <input type="text" className="form-control" value={line.note}
                      onChange={(e) => { const newData = [...data]; newData[index].note = e.target.value; setData(newData); }} />
                  </div>
                  <div className="col d-flex align-items-end">
                    <button className="btn btn-danger" onClick={() => removeRow(index)}>Remove</button>
                  </div>
                </div>
              ))}
            </center>
            <div>
              <button className="btn btn-secondary me-2" onClick={addRow}>+ Add Row</button>
              <button className="btn btn-success" onClick={submitRows}>Submit All</button>
            </div>
          </div>
        )}
        <hr />

        {/* FILTERS & BUTTONS */}
        <div className="row mt-6">
          {["f_internal_no", "r_internal_no", "effective_from_date", "effective_to_date", "note"].map(field => (
            <div className="col" key={field}>
              <input type={field.includes("date") ? "date" : "text"} className="form-control" placeholder={field}
                onChange={(e) => setFilters(prev => ({ ...prev, [field]: e.target.value }))} />
            </div>
          ))}
          <div className="col">
            <button className="btn btn-primary me-2" onClick={() => setEditable(!editable)}>Add Mapping</button>
            <button className="btn btn-success me-2" onClick={enableUpdateable}>Edit Dates/Note</button>
            {isAuthorizedForFullEdit() && (
              <button className="btn btn-warning me-2" onClick={enableFullEdit}>Edit All Fields</button>
            )}
            {fullEditMode && (
              <>
                <button className="btn btn-success me-2" onClick={saveFullEdits}>Save All Changes</button>
                <button className="btn btn-secondary" onClick={cancelFullEdits}>Cancel</button>
              </>
            )}
          </div>
        </div>

        {/* DATA TABLE */}
        <div className="datatable-wide_part mt-4">
          <table className="table table-bordered table-striped">
            <thead>
              <tr><th>F INTERNAL NO</th><th>R INTERNAL NO</th><th>EFFECTIVE FROM</th><th>EFFECTIVE TO</th><th>NOTE</th></tr>
            </thead>
            <tbody>
              {partRMap.map((val, idx) => (
                <tr key={idx}>
                  <td>
                    {fullEditMode ? (
                      <input type="text" className="form-control" value={val.f_internal_no || ""}
                        onChange={(e) => handleFullEditChange(idx, "f_internal_no", e.target.value)} />
                    ) : val.f_internal_no}
                  </td>
                  <td>
                    {fullEditMode ? (
                      <input type="text" className="form-control" value={val.r_internal_no || ""}
                        onChange={(e) => handleFullEditChange(idx, "r_internal_no", e.target.value)} />
                    ) : val.r_internal_no}
                  </td>
                  <td>
                    {(updateable || fullEditMode) ? (
                      <input type="date" className="form-control" value={val.effective_from ? val.effective_from.slice(0, 10) : ''}
                        onChange={(e) => fullEditMode ? handleFullEditChange(idx, "effective_from", e.target.value) : handleUpdateChange(idx, "effective_from", e.target.value)} />
                    ) : (val.effective_from ? val.effective_from.slice(0, 10) : '')}
                  </td>
                  <td>
                    {(updateable || fullEditMode) ? (
                      <input type="date" className="form-control" value={val.effective_to ? val.effective_to.slice(0, 10) : ''}
                        onChange={(e) => fullEditMode ? handleFullEditChange(idx, "effective_to", e.target.value) : handleUpdateChange(idx, "effective_to", e.target.value)} />
                    ) : (val.effective_to ? val.effective_to.slice(0, 10) : '')}
                  </td>
                  <td>
                    {(updateable || fullEditMode) ? (
                      <input type="text" className="form-control" value={val.note || ''}
                        onChange={(e) => fullEditMode ? handleFullEditChange(idx, "note", e.target.value) : handleUpdateChange(idx, "note", e.target.value)} />
                    ) : val.note}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {updateable && !fullEditMode && (
            <div className="mt-3"><button className="btn btn-success" onClick={saveOriginalUpdates}>Save Date/Note Updates</button></div>
          )}
        </div>

        <br />
        <button className="btn btn-info" onClick={fetchAuditLogs}>{showAudit ? "Refresh Activity Log" : "Show Activity Log"}</button>
        <hr />
        {showAudit && (
          <div className="mt-3 audit-log-container">
            <table className="table audit-log-table">
              <thead><tr><th>Timestamp</th><th>Changed By</th><th>F No</th><th>R No</th><th>Action</th><th>Changes</th></tr></thead>
              <tbody>
                {auditLogs.map((log, idx) => {
                  const changes = [];
                  if (log.Action_Type === 'INSERT') {
                    changes.push(`New record: F=${log.f_internal_no}, R=${log.r_internal_no}, From=${log.New_effective_from || ''}, To=${log.New_effective_to || ''}, Note=${log.New_note || ''}`);
                  } else if (log.Action_Type === 'UPDATE_FULL') {
                    // Key changes
                    if (log.Old_f_internal_no !== log.f_internal_no)
                      changes.push(`F Internal No: ${log.Old_f_internal_no} → ${log.f_internal_no}`);
                    if (log.Old_r_internal_no !== log.r_internal_no)
                      changes.push(`R Internal No: ${log.Old_r_internal_no} → ${log.r_internal_no}`);
                    // Date and note changes
                    if (log.Old_effective_from !== log.New_effective_from)
                      changes.push(`Effective From: ${log.Old_effective_from || '—'} → ${log.New_effective_from || '—'}`);
                    if (log.Old_effective_to !== log.New_effective_to)
                      changes.push(`Effective To: ${log.Old_effective_to || '—'} → ${log.New_effective_to || '—'}`);
                    if (log.Old_note !== log.New_note)
                      changes.push(`Note: ${log.Old_note || '—'} → ${log.New_note || '—'}`);
                  }
                  return (
                    <tr key={idx}>
                      <td>{new Date(log.Change_Timestamp).toLocaleString()}</td>
                      <td>{log.Changed_By}</td>
                      <td>{log.f_internal_no}</td>
                      <td>{log.r_internal_no}</td>
                      <td><span className={`action-badge ${log.Action_Type === 'INSERT' ? 'badge-insert' : 'badge-full'}`}>{log.Action_Type}</span></td>
                      <td>{changes.length === 0 ? <span className="no-change">No visible changes</span> : changes.map((c, i) => <div key={i} className="change-item">{c}</div>)}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}

        {/* Datalists */}
        <datalist id="FInternalNoList">{partRMap.map((x, i) => <option key={i} value={x.f_internal_no} />)}</datalist>
        <datalist id="RInternalNoList">{partRMap.map((x, i) => <option key={i} value={x.r_internal_no} />)}</datalist>
      </div>
    </div>
  );
}

export default Part_R_Map;